import { connect } from 'react-redux'
import { WireMoney } from 'components/Profile'

export default connect(
)(WireMoney)
